import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer glass-effect">
      <div className="footer-content">
        <div className="footer-section about">
          <h3 className="logo-text">LAPVocab</h3>
          <p>Master vocabulary the smart and organized way. Your personal partner in language learning.</p>
        </div>
        <div className="footer-section links">
          <h4>Navigate</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/studio">Content Studio</Link></li>
            <li><Link to="#">About Us</Link></li>
          </ul>
        </div>
        <div className="footer-section links">
          <h4>Resources</h4>
          <ul>
            <li><Link to="#">Help Center</Link></li>
            <li><Link to="#">Terms of Service</Link></li>
            <li><Link to="#">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="footer-section contact">
          <h4>Follow Us</h4>
          <div className="socials">
            <a href="#"><i className="fab fa-facebook"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} LAPVocab. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;